import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as DevModules from 'devextreme-angular';

import { KmmNgBackendModule } from 'kmm-ng-backend';

import { DynamicGridComponent } from './dynamic-grid.component';
import {
   GridColumnComponent,
   GridTemplate,
   GridOptionsColumn,
   CustomItem,
   GridColumnTemplate,
   GridDataSourceComponent
} from '../grid-column.component';

import { DynamicFilterModule } from '../dynamic-filter/dynamic-filter.module';
import { ModeloGridModule } from '../modelo-grid/modelo-grid.module';

@NgModule({
   imports: [
      CommonModule,
      DevModules.DxButtonModule,
      DevModules.DxDataGridModule,
      DynamicFilterModule,
      KmmNgBackendModule,
      ModeloGridModule
   ],
   exports: [
      CustomItem,
      GridColumnComponent,
      GridColumnTemplate,
      GridDataSourceComponent,
      GridOptionsColumn,
      GridTemplate,
      DynamicGridComponent
   ],
   declarations: [
      CustomItem,
      GridColumnComponent,
      GridColumnTemplate,
      GridDataSourceComponent,
      GridOptionsColumn,
      GridTemplate,
      DynamicGridComponent,
   ],
   entryComponents: [
      CustomItem,
      GridColumnComponent,
      GridColumnTemplate,
      GridDataSourceComponent,
      GridOptionsColumn,
      GridTemplate,
      DynamicGridComponent
   ],
   providers: []
})
export class DynamicGridModule { }
